import { useNavigate } from "react-router-dom";

import { LightningSlashIcon } from "@/modules/common/assets/icons";
import { Button } from "@/modules/common/components";
import { ROUTES } from "@/routes/constants/routes";

interface Page404Props {
  description?: string;
}

const Page404 = ({ description }: Page404Props) => {
  const navigate = useNavigate();

  return (
    <div className="relative flex h-screen items-center justify-center overflow-hidden">
      <LightningSlashIcon className="absolute w-125 h-125 opacity-[0.04] pointer-events-none" />

      <div className="relative z-10 text-center">
        <h1 className="text-5xl font-bold leading-none text-ui-text">404</h1>
        <p className="mt-2 text-xl font-semibold text-ui-text">Página não encontrada</p>
        <p className="mt-2 text-sm text-gray-400">{description ?? "A página que você está procurando não existe ou foi removida"}</p>

        <div className="mt-8 flex items-center justify-center gap-3">
          <Button variant="outlined" color="primary" label="Voltar" onClick={() => navigate(-1)} />
          <Button variant="contained" color="primary" label="Voltar à home" route={ROUTES.DASHBOARD.HOME} />
        </div>
      </div>
    </div>
  );
};

export default Page404;
